/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import Library from './library';
import { AdTargetingEngine } from './targeting/engine';
import { compareVersions } from './util';

declare global {
  interface Window {
    $nodals: any;
  }
}

/*
 * Basic usage:
 *
 *  const targetingEngine = window.$nodals.AdTargetingEngine['1.x.x'];
 *  targetingEngine.init(config);
 *  // whatever API you want to invoke
 */
(() => {
  window.$nodals = window.$nodals || {};
  window.$nodals.adTargetingEngine = window.$nodals.adTargetingEngine || {};
  if (typeof window.$nodals.adTargetingEngine[Library.version] === 'undefined') {
    const engine: AdTargetingEngine = AdTargetingEngine.getInstance();
    let setAsLatestMajorVersion: boolean = true;
    if (typeof window.$nodals.adTargetingEngine[Library.MAJOR_VERSON_PATTERN] !== 'undefined') {
      const currentMajorVersion =
        window.$nodals.adTargetingEngine[Library.MAJOR_VERSON_PATTERN].getVersion();
      const thisVersion = engine.getVersion();
      if (compareVersions(thisVersion, currentMajorVersion) === currentMajorVersion) {
        setAsLatestMajorVersion = false;
      }
    }
    window.$nodals.adTargetingEngine[Library.version] = engine;
    if (setAsLatestMajorVersion) {
      window.$nodals.adTargetingEngine[Library.MAJOR_VERSON_PATTERN] = engine;
    }
  }
})();
